import { useCalculatedTimeDifference } from "./CalculatedTimeDifference";
import { onDateFormate } from "./DateFormate";

export const generateFormattedData = (
  data,
  type,
  user,
  depositWaitingQueue,
  depositVerifactionTab,
  startIndex = 0,
) => {
  return data.map((item, index) => {
    const calculatedTimeDifference = useCalculatedTimeDifference();
    const isVendor =
      item?.actionBy?.userType === "vendor" && user?.userType === "vendor";
    const isOperator =
      item?.actionBy?.userType === "operator" &&
      item?.actionBy?.userType === "operator" &&
      user?._id === item?.actionBy?._id;

    let userId =
      type === "depositReport"
        ? item.sender?.uniqueId
        : item.user?.uniqueId || "-";

    let entityId =
      type === "depositReport"
        ? item?.senderWebsite?.uniqueId
        : item?.website?.uniqueId || "-";

    const formattedData = {
      "Sr No": startIndex + index + 1,
      ...(type !== "depositReport" && {
        "Request Process":
          item?.isDepositReqAutoApproval === false
            ? "Auto to Manual"
            : item?.isDepositReqAutoApproval === true
              ? "Move to Manual"
              : "Manual",
      }),
      ...(type === "depositReport" && {
        "Request Process":
          item?.isDepositReqAutoApproval === true
            ? "Auto"
            : item?.isDepositReqAutoApproval === false
              ? "Auto to Manual"
              : "Manual",
      }),
      ...(type === "depositReport" && {
        "User Name": item?.sender?.name ? item?.sender?.name : "-",
      }),
      "PG Transaction ID": item?.traId || "-",
      "UTR Transaction ID": item?.gatewayTraId || "-",
      ...((type === "depositReport" || depositVerifactionTab) && {
        "Change UTR Transaction ID": item?.changeGatewayTraId || "-",
      }),
      "UTR ID":
        item?.reqType === "upi" && item?.transactionId
          ? `${item?.transactionId} ${
              item?.upiId ? `[${item?.upiId ? item?.upiId : "-"}]` : ""
            }`
          : "-" || "-",
      Amount: item.amount || "-",
      ...((type === "depositReport" || depositVerifactionTab) && {
        "User Amount": item?.changeAmount || "-",
      }),
      "Received Amount": item.receivedAmount || "-",
      Status: item.status || "-",
      "User Id": userId,
      "Entity Id": entityId,
      Coin: item?.coin?.name || "-",
      "Crypto Amount": item?.usdtAmount || "-",
      "Coin Network": item.coinNetwork?.name || "-",
      "Request Type": item?.reqType || "-",
      ...(depositVerifactionTab && {
        "Action By":
          isVendor || isOperator ? "Own" : item.actionBy?.name || "-",
      }),
      ...(type === "depositReport" && {
        "UPI ID":
          item.accountHistory && item.accountHistory.length > 0
            ? item.accountHistory[1]?.transferAccount?.upiId || "-"
            : item?.receiverAccount?.upiId || "-",
        "Account Holder Name":
          item.accountHistory && item.accountHistory.length > 0
            ? item.accountHistory[1]?.transferAccount?.name || "-"
            : item?.receiverAccount?.name || "-",
        "Bank Name":
          item?.accountHistory && item?.accountHistory?.length > 0
            ? item?.accountHistory[1]?.transferAccount?.bankName || "-"
            : item?.receiverAccount?.bankName || "-",
        "Account Number":
          item?.accountHistory && item?.accountHistory?.length > 0
            ? item?.accountHistory[1]?.transferAccount?.accountNum || "-"
            : item?.receiverAccount?.accountNum || "-",
        IFSC:
          item?.accountHistory && item?.accountHistory?.length > 0
            ? item?.accountHistory[1]?.transferAccount?.ifsc || "-"
            : item?.receiverAccount?.ifsc || "-",
        "Action By":
          item?.actionBy?.userType === "admin"
            ? "TES"
            : user?.userType === "operator" && item?.actionBy
              ? "Own"
              : user?.userType === "operator" && !item?.actionBy
                ? item?.receiver?.name
                : item.actionBy?.name
                  ? item.actionBy?.name
                  : "Own",
      }),
      ...(type !== "depositReport" && {
        "UPI ID": item?.depositAccount?.upiId
          ? item?.depositAccount?.upiId
          : "-",
        "Bank Name": item?.depositAccount?.bankName
          ? item?.depositAccount?.bankName
          : "-",
        "Account Number": item?.depositAccount?.accountNum
          ? item?.depositAccount?.accountNum
          : "-",
        IFSC: item?.depositAccount?.ifsc ? item?.depositAccount?.ifsc : "-",
      }),
      "Created Date":
        onDateFormate(item?.createdAt, "DD-MM-YYYY hh:mm A") || "-",
      "Updated Date":
        onDateFormate(item?.updatedAt, "DD-MM-YYYY hh:mm A") || "-",
      ...(type === "depositReport" && {
        "Time Differenece":
          calculatedTimeDifference(item?.createdAt, item?.updatedAt) || "-",
        Remarks: item?.remark || "-",
      }),
      Image: item?.reqType === "bank" ? item?.paymentSS : "-" || "-",
      ...(type !== "depositReport" &&
        depositWaitingQueue && {
          "Waiting Queue": item?.depositWaitingTime || "-",
        }),
    };
    return formattedData;
  });
};

export const generateWithdrawReportFormattedData = (
  data,
  type,
  user,
  startIndex = 0,
) => {
  return data.map((item, index) => {
    const calculatedTimeDifference = useCalculatedTimeDifference();

    const formattedData = {
      "Sr No": startIndex + index + 1,
      "PG Transaction ID": item?.traId || "-",
      "UTR Transaction ID": item?.gatewayTraId || "-",
      "User Name": item?.receiver.name || "-",
      "User ID": item?.receiver.uniqueId || "-",
      "Entity Id": item?.senderWebsite?.uniqueId || "-",
      Amount: item.amount || "-",
      "Request Type": item.reqType || "-",
      ...(user?.userType === "operator" && {
        "Action By": item.actionBy ? "Own" : item?.sender?.name,
      }),
      ...(user?.userType !== "operator" && {
        "Action By": item.actionBy ? item.actionBy?.name : "Own",
      }),
      "Receiver Account Type": item?.receiverAccount?.type || "-",
      "Receiver UPI ID": item?.receiverAccount?.upiId || "-",
      "Receiver Bank Name": item?.receiverAccount?.bankName || "-",
      "Receiver Bank Holder Name": item?.receiverAccount?.accHolderName || "-",
      "Receiver Account No": item?.receiverAccount?.accountNum || "-",
      "Receiver IFSC": item?.receiverAccount?.ifsc || "-",
      "Receiver Network": item?.receiverAccount?.network || "-",
      "Receiver Wallet Address":
        item?.receiverAccount?.cryptoWalletAddress || "-",
      "Sender Account Type": item?.senderAccount?.type || "-",
      "Sender UPI ID": item?.senderAccount?.upiId || "-",
      "Sender Bank Name": item?.senderAccount?.bankName || "-",
      "Sender Bank Holder Name": item?.senderAccount?.name || "-",
      "Sender Account No": item?.senderAccount?.accountNum || "-",
      "Sender IFSC": item?.senderAccount?.ifsc || "-",
      "Sender Network": item?.senderAccount?.network || "-",
      "Sender Wallet Address": item?.senderAccount?.cryptoWalletAddress || "-",
      "Created Date":
        onDateFormate(item.withdrawReqCreatedAt, "DD-MM-YYYY hh:mm:ss A") || "-",
      "Updated Date":
        onDateFormate(item.updatedAt, "DD-MM-YYYY hh:mm:ss A") || "-",
      "Time Difference":
        calculatedTimeDifference(
          item?.withdrawReqCreatedAt
            ? item?.withdrawReqCreatedAt
            : item?.depositReqCreatedAt,
          item.updatedAt,
        ) || "-",
      Status: item.status || "-",
      Remarks: item?.remark || "-",
    };

    return formattedData;
  });
};

export const generateWithdrawQueueFormattedData = (data, type) => {
  return data.map((item, index) => {
    const formattedData = {
      "Sr No": index + 1,
      Status:
        item?.status === "verified" && item?.isBalanceVerified === true
          ? "Verified"
          : item?.status === "verified"
            ? "Verify Balance"
            : item?.status,
      "UPI ID": item?.accountId?.upiId || "-",
      "PG Transaction ID": item?.traId || "-",
      "User ID": item?.user?.uniqueId || "-",
      "Entity Id": item?.website?.uniqueId || "-",
      Amount: item.amount || "-",
      "Pending Amount": item?.pendingAmount || "00",
      "Paid Amount": item?.paidAmount || "00",
      "Request Type": item?.reqType || "-",
      "Bank Name":
        item?.accountId?.type === "crypto"
          ? item?.accountId?.coin
          : item?.accountId?.bankName || "-",
      "Account No":
        item?.accountId?.type === "crypto"
          ? item?.accountId?.address
          : item?.accountId?.accountNum || "-",
      IFSC:
        item?.accountId?.type === "crypto"
          ? item?.accountId?.network
          : item?.accountId?.ifsc || "-",
      "Created Date":
        onDateFormate(item.createdAt, "DD-MM-YYYY hh:mm A") || "-",
      "Updated Date":
        onDateFormate(item.updatedAt, "DD-MM-YYYY hh:mm A") || "-",
      "Expired Time": onDateFormate(item.expiry, "DD-MM-YYYY hh:mm A") || "-",
    };

    return formattedData;
  });
};

export const generateWebsiteReportData = (data) => {
  return data.map((item, index) => {
    const formattedData = {
      "Sr No": index + 1,
      "Entity Id": item.uniqueId,
      "Deposit Success": item?.transactions?.totalDepositAmount
        ? (item?.transactions?.totalDepositAmount).toFixed(2)
        : "00",
      "Withdraw Success": item?.transactions?.totalWithdrawAmount
        ? (item?.transactions?.totalWithdrawAmount).toFixed(2)
        : "00",
      DMW:
        item?.transactions?.totalDepositAmount ||
        item?.transactions?.totalWithdrawAmount
          ? (
              item?.transactions?.totalDepositAmount -
              item?.transactions?.totalWithdrawAmount
            ).toFixed(2)
          : "00",
    };
    return formattedData;
  });
};

export const generateTransactionListReportData = (data) => {
  return data.map((item, index) => {
    const formattedData = {
      "Sr No": index + 1,
      Date: onDateFormate(item.createdAt, "DD-MM-YYYY hh:mm A") || "-",
      "PG Transaction ID": item?.traId || "-",
      "Receiver Account":
        item?.receiverAccount?.upiId || item?.depositAccount?.upiId || "-",
      "Receiver Type":
        item?.receiver?.userType || item?.depositAccount?.owner || "-",
      "Receiver Name": item?.receiver?.name || item?.created?.name || "-",
      Amount: item?.amount || "-",
      "Received Amount": item?.receivedAmount || "-",
      Status: item?.status || "-",
    };

    return formattedData;
  });
};
